import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Crown } from "lucide-react";

const SECTIONS = [
  { h: "1. Information we collect", p: "We collect your name and email at registration, the scalp photos and questionnaire answers you submit, your scan reports and history, reviews you leave, and payment status information from our provider (we do not store card numbers)." },
  { h: "2. How we use your information", p: "To create and analyse your scalp reports, maintain your scan history, process the scan fee, improve the Service, and communicate with you about your account." },
  { h: "3. Your photos", p: "Scalp photos you upload are used to generate your report and are stored with your account so you can revisit past reports. They are not sold or shared for advertising." },
  { h: "4. Analysis processing", p: "Your photo and answers are processed by a trusted analysis provider solely to generate your report. We do not use your images to publicly identify you." },
  { h: "5. Payments", p: "Payments are handled by iKhokha. Their handling of payment data is governed by their own privacy policy." },
  { h: "6. Data retention", p: "We retain your account and scan history until you request deletion. You may contact us to delete your account and associated data." },
  { h: "7. Security", p: "We use industry-standard measures, including hashed passwords and secured access tokens, to protect your data. No method is 100% secure, but we work to safeguard your information." },
  { h: "8. Your rights", p: "You may request access to, correction of, or deletion of your personal information by contacting us at the email in the footer." },
  { h: "9. Contact", p: "For any privacy questions or requests, reach us via the contact details in the site footer." },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-charcoal text-cream">
      <Navbar />
      <div className="mx-auto max-w-3xl px-6 py-14" data-testid="privacy-page">
        <span className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-gold"><Crown className="h-4 w-4" /> Legal</span>
        <h1 className="mt-2 font-heading text-4xl text-cream md:text-5xl">Privacy Policy</h1>
        <p className="mt-2 text-sm text-muted-foreground">Draft — subject to final review. Last updated {new Date().getFullYear()}.</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s, i) => (
            <div key={i}>
              <h2 className="mb-2 font-heading text-2xl text-cream">{s.h}</h2>
              <p className="text-sm leading-relaxed text-muted-foreground">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
